import { cn } from "../../lib/cn";

type SpinnerSize = "sm" | "md" | "lg";

type SpinnerProps = {
	size?: SpinnerSize;
	className?: string;
};

const sizeStyles: Record<SpinnerSize, string> = {
	sm: "h-4 w-4 border-2",
	md: "h-6 w-6 border-2",
	lg: "h-10 w-10 border-3",
};

export function Spinner({ size = "md", className }: SpinnerProps) {
	return (
		<output
			aria-label="Loading"
			className={cn(
				"animate-spin rounded-full border-pastel-border border-t-pastel-vibrant-blue",
				sizeStyles[size],
				className
			)}
		>
			<span className="sr-only">Loading...</span>
		</output>
	);
}
